export default __webpack_public_path__ + "static/media/img-2.51d27fb9.jpg";